module.exports = __webpack_public_path__ + "img/ppgy.baa9dabe.png";